import { useFrame } from "@react-three/fiber";
import { Text } from '@react-three/drei';
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { cameraActions } from "../redux/cameraSlice";
import { interactionActions } from "../redux/interactionSlice";
import { LabelInteractionMetadata } from "../models/Model3D";


export type InteractionElementFloatingLabelProps = {
  interaction: LabelInteractionMetadata;
}
const labelBoxLengthMultiplier = 0.06;

export const InteractionElementFloatingLabel = (props: InteractionElementFloatingLabelProps) => {
  const { label, action } = props.interaction;
  const [isHovered, setIsHovered] = useState(false);
  const boxLength = label.text.length * labelBoxLengthMultiplier;
  const boxRef = useRef<any>();
  const dispatch = useDispatch();


  useFrame(({ camera }) => {
    if (boxRef.current) {
      boxRef.current.lookAt(camera.position);
    }
  });


  const onClick = () => {
    // for some reason if you click on the label, it will trigger this twice?
    if (action?.toggleStates) {
      dispatch(interactionActions.toggleStates(action.toggleStates))
    }
    if (action?.setStates) {
      dispatch(interactionActions.setState(action.setStates))
    }
    if (action?.moveCamera !== undefined) {
      dispatch(cameraActions.setTargetPoint(action.moveCamera))
    }
    if (action?.boundary !== undefined) {
      dispatch(interactionActions.setBoundary(action.boundary))
    }
  }

  return <mesh ref={boxRef} position={label.position} onPointerEnter={() => setIsHovered(true)} onPointerLeave={() => setIsHovered(false)} onClick={onClick}>
    <boxGeometry args={[boxLength, 0.2, 0.1]} />
    <meshBasicMaterial color='yellow' transparent opacity={isHovered ? 1 : 0.6} />
    <Text fontSize={0.1} color='black' anchorX='center' anchorY='middle' position={[0, 0, 0.1]} onClick={(event) => {
      // preventing double trigger event: text and box geometry
      event.stopPropagation();
      onClick();
    }}>
      {label.text}
    </Text>
  </mesh>
}